import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Testimonials" className="bg-ink" data-id="element-316" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "16px"
    }} data-id="element-317" data-mp="3fym6mihn2y3a">
        <div className="mx-auto max-w-2xl text-center" data-id="element-318" data-mp="3azt2vhs5mlgb">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-319" data-mp="36ypo6yluevgo">A practical system built for security professionals</p>
          <h2 className="mt-3 font-display text-3xl font-bold uppercase text-fog sm:text-4xl" data-id="element-320" data-mp="31yuvcpiibvsz">🗣️ Real-World Experiences</h2>
          <p className="mt-3 text-[15px] text-fog/70" data-id="element-321" data-mp="2x11tu9s5fpz1">
            120 prompts across six core volumes, plus four complementary resources for reporting, shift handovers,
            professional communication, and AI implementation.
          </p>
        </div>
        <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-322" data-mp="qa3rjeqnthsd">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.06} data-id="element-323" data-mp="h5oqvedtac90" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}